<template>
  <div class="selector pt-0" v-if="mannequins.length">
    <div class="selector__actions-group">
      <button :class="item.type === mannequin.type ? 'active' : ''"
              class="selector__action"
              v-for="item in mannequins"
              :key="item.type"
              @click="changeMannequin({ payload: item, loadDefaultClothes: true })"
              v-text="item.type"></button>

    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: "MannequinsSelector",
    computed: {
      ...mapGetters('mannequin',[
        'mannequins',
        'mannequin'
      ])
    },
    methods: {
      ...mapActions('mannequin',[
        'setMannequin'
      ]),
      ...mapActions('clothes',[
        'clothesPreloading',
      ]),
      changeMannequin(payload) {
        this.$Progress.start();

        this.setMannequin(payload).then(() => {
          this.$Progress.finish();
          // this.clothesPreloading();
        }).catch(() => {
          this.$Progress.fail();
        });
      }
    }
  }
</script>

<style scoped>

  .selector__actions-group {
    display: flex;
    justify-content: center;
  }

  .selector__action {
    width: max-content;
    display: inline-block;
    height: 35px;
    padding: 0 15px;
    font-size: 14px;
    border-radius: 35px;
    line-height: 35px;
    text-align: center;
    margin-right: 15px;
    border: 1px solid #7C7C7C;
    transition: all 0.3s ease-in-out;
    background-color: rgba(255,255,255,0.4);
  }

  .selector__action:last-child {
    margin-right: 0px;
  }

  .selector__action:hover {
    background-color: white;
  }

  .selector__action.active {
    color: red;
    border-color: red;
    background-color: white;
  }

  @media only screen and (max-width: 1024px) {
    .selector__action {
      height: 30px;
      font-size: 12px;
      border-radius: 30px;
      line-height: 30px;
    }

  }
</style>